import React from 'react';
import PropTypes from 'prop-types';
import { Col, FlexRow, Pill } from '@edreamsodigeo/prisma-design-system';

export const PrimePill = ({ children, type, icon }) => {
  return (
    <Pill
      type={type}
      theme={'default'}
      rounded
      sx={{ maxWidth: '175px', fontSize: '14px' }}
    >
      <FlexRow gap={1} flexDirection="row" alignItems="center">
        <Col>{icon}</Col>
        <Col>{children}</Col>
      </FlexRow>
    </Pill>
  );
};

PrimePill.propTypes = {
  icon: PropTypes.element,
  type: PropTypes.oneOf([
    'positive',
    'informative',
    'neutral',
    'brand',
    'promotional',
  ]),
};

PrimePill.defaultProps = {
  type: 'informative',
};
